import {
  SignedIn,
  SignedOut,
  SignIn,
  SignOutButton,
  useUser,
} from "@clerk/clerk-react";
import { Dashboard } from "./Dashboard";

export function App() {
  return (
    <>
      <SignedOut>
        <SignInScreen />
      </SignedOut>
      <SignedIn>
        <AuthedShell />
      </SignedIn>
    </>
  );
}

function SignInScreen() {
  return (
    <main style={{ display: "grid", placeItems: "center", minHeight: "80vh" }}>
      <div>
        <h1 style={{ textAlign: "center", marginBottom: 16 }}>
          FileVouch Dashboard
        </h1>
        <SignIn routing="hash" />
      </div>
    </main>
  );
}

function AuthedShell() {
  const { user } = useUser();
  return (
    <>
      <header className="top">
        <div className="brand">FileVouch</div>
        <div className="row">
          <span className="muted">{user?.primaryEmailAddress?.emailAddress}</span>
          <SignOutButton>
            <button className="secondary" type="button">Sign out</button>
          </SignOutButton>
        </div>
      </header>
      <main>
        <Dashboard />
      </main>
    </>
  );
}
